var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"alt":"logo lm-equipement","src":require("@/assets/logo-LM-EQUIPEMENT.svg")}}),_c('Accueil',{attrs:{"msg":"Bienvenue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }